import React, { Fragment, useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";
import DataTable from "../../../../Common/Components/DataTable";
import Loading from "../../../../Common/Components/Loading";
import CustomModal from "../../../../Common/Components/Modal/CustomModal";
import { useStatusAthelets } from "../Hooks";
import TimePicker from "../../../../Common/Components/TimePicker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import { Calendar } from "react-multi-date-picker";
import { ConvertDate } from "../../../../Common/Function/index";
import { Set } from "../../../../../Request";
import { useSelector } from "react-redux";
import ItemAthlet from "../../../../../App/Panel/Athletes/subsets/ItemAthlet";
import TableSearch from "../../../../Common/Components/DataTable/TableSearch";
import { RtlMui } from "../../../../../App/component/rtlMui";
import { BsFilter } from "react-icons/bs";

const ActiveList = ({ form, setForm, isApp, timekey }) => {
  const { data, getActive, loading, searchHandlerActive, paginateActive } = useStatusAthelets();
  const [reverseData, SetReverseData] = useState(false)
  const [selectAll, setSelectAll] = useState(false)
  const [orders, setOrders] = useState()

  const { user: { item } } = useSelector(state => state);
  const [modal, setModal] = useState({ visible: false });
  const renderHeader = arr => {
    if (item[0].timetable_option.needsession == "true") {
      return arr;
    } else {
      return arr.filter(ro => {
        if (ro.key !== "persence_count") {
          return ro;
        }
      });
    }
  };
  const renderLink = arr => {
    if (item[0].timetable_option.needsession == "true") {
      return arr;
    } else {
      return [];
    }
  };
  useEffect(() => {
    if (!modal.visible) {
      getActive({ timekey: timekey });
    }
  }, [modal.visible]);
  const navigate = useNavigate();

  const finalData = (data) => {
    if (reverseData) {
      return data.slice(0).reverse()
    }
    return data
  }

  return (
    <Fragment>
      <Helmet>
        <title>نیکوتن | لیست کامل ورزشکاران</title>
      </Helmet>

      <Fragment>

        {isApp && <>

          <div className="my-4" style={{ color: reverseData ? "red" : "blue" }} onClick={() => SetReverseData(!reverseData)}>
            <BsFilter className={"ml-2"} size={24} />
            {reverseData ? "قدیمی‌ترین" : "جدیدترین"}
          </div>
          <RtlMui>
            <TableSearch className={"mb-2"} label={"جستجوی کاربر بر اساس نام، شماره تماس یا کد ملی"} search={searchHandlerActive} />
          </RtlMui>

          <div className="d-flex justify-content-between my-2">
            <div class="form-check pr-4">
              <input class="form-check-input" type="checkbox" id="selectAll" style={{ marginRight: "-20px" }}
                onChange={e => {
                  setSelectAll(!selectAll)
                  let obj = [];
                  data?.data.map(item => {
                    obj.push({
                      order_id: item.order_id,
                      reseves: item.reserve_id
                    })
                  })
                  setOrders(obj)
                }} />
              <label class="form-check-label" for="selectAll">
                انتخاب همه
              </label>
            </div>
            {selectAll &&
              <button className="btn btnMain px-3"
                onClick={e => setModal({
                  visible: true,
                  data: { orders }
                })}>
                ثبت
              </button>}
          </div>

          {loading.list
            ? <Loading col="12" height="50px" count="3" />
            : data.data.length > 0
              ? finalData(data.data).map((item, index) => (
                <ItemAthlet timekey={timekey} data={item} key={index} selectAll={selectAll}
                  eventPA={(isSelect) => {
                    if (selectAll) {
                      let obj;
                      if (isSelect) {
                        obj = orders;
                        obj.push({
                          order_id: item.order_id,
                          reseves: item.reserve_id
                        })
                      }
                      else {
                        obj = orders.filter(data => {
                          return data.order_id != item.order_id;
                        })
                      }
                      setOrders(obj)
                    }
                    else {
                      setModal({
                        visible: true,
                        data: item
                      })
                    }
                  }
                  }
                />
              ))
              : <p className="text-center mt-3 bg-transparent">  ورزشکاری یافت نشد !   </p>
          }
        </>}

        {!isApp && <DataTable
          loading={loading.list}
          heads={renderHeader([
            {
              title: "نام نام خانوادگی",
              key: "fullname",
            },
            {
              title: "کد ملی",
              key: "national_code",
            },
            {
              title: "شماره همراه",
              key: "mobile",
            },
            {
              title: "تاریخ آخرین خرید",
              key: "date_reserve",
              type: "date",
              timetype: "date-time",
            },
            {
              title: "تعداد روز های باقی مانده",
              key: "left_days",
            },
            {
              title: "تعداد حضور",
              key: "persence_count",
            },
          ])}
          search={searchHandlerActive}
          textEmpty="ورزشکار فعالی یافت نشد"
          list={data.data}
          data={data}
          function={paginateActive}
          currentPage={data.current_page}
          header="لیست ورزشکاران فعال"
          links={renderLink([
            {
              function: selected => {
                navigate(
                  "/User/PAList/" +
                  data.data.map(res => {
                    if (res.id == selected[0]) {
                      return res.reserve_id;
                    }
                  })[0]
                );
              },
              color: "success",
              size: "col-md-2",
              html: "لیست حضور",
              type: "show",
            },
            {
              function: selected => {
                if (form) {
                  setForm({
                    ...form,
                    step: "time",
                    athele: data.data.filter(user => user.id == selected[0])[0],
                  });
                } else {
                  setModal({
                    visible: true,
                    data: data.data
                      .filter(item => {
                        if (item.id === selected[0]) {
                          return item;
                        }
                      })
                      .filter(Boolean)[0],
                  });
                }
              },
              color: "success",
              size: "col-md-2",
              html: "ثبت حضور",
              type: "go",
              main: true,
            },
          ])}
        />}

        <CustomModal
          size={"md"}
          show={modal.visible}
          header={"ثبت حضور"}
          handleClose={() => {
            setModal({ visible: false });
          }}
        >
          <Modal modal={modal} setModal={setModal} timekey={timekey} isApp={isApp} selectAll={selectAll} />
        </CustomModal>
      </Fragment>
    </Fragment>
  );
};
const Modal = ({ modal, setModal, timekey, isApp, selectAll }) => {
  const [loading, setLoading] = useState({ absent: false });
  const confirm = async data => {
    setLoading({ ...loading, absent: true });
    Set({
      url: "/order/confirm_pa",
      data: data,
    }).then(res => {
      setLoading({ ...loading, absent: false });
      setModal({});
      setStep(1);
    });
  };
  const [step, setStep] = useState(1);
  switch (step) {
    case 1:
      return (
        <div className="d-flex justify-content-evenly">
          <div className="px-1" style={isApp ? { flex: "0 0 50%" } : { flex: 1 }}>
            <button className={"btn btn-success " + (isApp && "w-100")}
              onClick={() => {

                confirm({
                  type: "now",
                  ...modal.data,
                  reseves: modal.data.reserve_id,
                });

              }} >
              اکنون
            </button>
          </div>
          <div className="px-1" style={isApp ? { flex: "0 0 50%" } : {}}>
            <button className={"btn btn-danger " + (isApp && "w-100")}
              onClick={() => {
                setStep(2);
              }}
            >
              تاریخ دیگر
            </button>
          </div>
        </div>
      );
      break;
    case 2:
      return (
        <div>
          <h6>لطفا تاریخ و ساعت حضور را وارد کنید</h6>
          <div className="mt-4">
            <TimePicker
              form={modal}
              setForm={setModal}
              element={{
                key: "time",
                name: "ساعت حضور",
              }}
            />
          </div>
          <div className={`my-2`}>
            <label htmlFor="" >
              تاریخ حضور
            </label>
            <Calendar
              // range={true}
              onChange={data => {
                setModal({
                  ...modal,
                  date: ConvertDate(
                    `${data.year}/${data.month.number}/${data.day}`
                  ),
                });
              }}
              calendar={persian}
              // multiple={true}
              locale={persian_fa}
            />
            <div className="mt-3 d-flex justify-content-center">
              {console.log(modal)}
              <button               
                onClick={() => {
                  confirm({
                    type: "withdate",
                    ...modal.data,
                    reseves: modal.data.reserve_id,
                  });
                }}
                className={`btn d-flex justify-content-center btn-danger `}
                style={{ width: "120px" }}
              >
                {!loading.absent ? "ثبت" : "در حال ارسال"}
              </button>
            </div>
          </div>
        </div>
      );
    default:
      break;
  }
  return <div></div>;
};

export default ActiveList;
